module.exports = __webpack_public_path__ + "img/logo_Primeroseguros.569b650b.svg";